export default __webpack_public_path__ + "6501b4245688b16f370ab30311ef9e53.png";